import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { BaasMenuButton, BaasMenuButtonItemOptions } from '@lvflanders/bar-ng-ui';

export interface IBarMenuButtonCellRendererParams extends ICellRendererParams {
    /** Optional CSS class of icon to use. */
    iconClass?: string;
    /** Optional content to show in the master button. */
    content?: string;
    /** Whether disabled. */
    disabled?: boolean;
    /** Whether hidden. */
    hidden?: boolean;
    /** Tooltip for the master button. */
    tooltip?: string;
    /** The child items. */
    items?: BaasMenuButtonItemOptions[];
}

@Component({
    template: `@if (!params.hidden) {
        <baas-menu-button
            [content]="params.content"
            [items]="params.items"
            [disabled]="params.disabled"
            [tooltip]="params.tooltip"
            [iconClass]="params.iconClass"
        >
        </baas-menu-button>
    }`,
    selector: 'baas-menu-button-cell-renderer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BaasMenuButton]
})
/** BAR ag-grid cell renderer to render a BAR action button. */
export class BarMenuButtonCellRenderer implements ICellRendererAngularComp {
    params: IBarMenuButtonCellRendererParams;

    refresh(params: any): boolean {
        return false;
    }

    agInit(params: IBarMenuButtonCellRendererParams): void {
        this.params = params;
    }
}
